






import { Component, Vue } from 'vue-property-decorator';

import api from '@/util/api';

@Component ({})
export default class Confirm extends Vue
{
	setMessage (message: string, details: string, error = false, nextUrl: string|null = null)
	{
		return this.$store.dispatch ('setMessage', { message, details, error, nextUrl });
	}

	async created ()
	{
		try
		{
			this.confirm ();
		}
		catch (e)
		{
			this.setMessage ('Error', e.message, true);
		}
	}

	async confirm ()
	{
		if (!this.$route)
			throw new Error ('No route found');
		if (!this.$route.query)
			throw new Error ('No query found');
		if (!this.$route.query.t)
			throw new Error ('No tag ID found');
		const id = this.$route.query.t;
		// @ts-ignore
		await api.confirmRegistration (id);
		this.setMessage (
			'OK', 'Confirmado', false,
			'http://nomepierdo.cl/bienvenido-a-nomepierdo-cl/');
	}
}

